import css from 'styled-jsx/css';
import { MQ_LARGE, MQ_MEDIUM, MQ_MIDLARGE, MQ_XLARGE } from 'constants/mq';
import { warmGrays } from 'styles/colors/constants';

export const baseStyles = css`
  .SlideGallery {
    outline: none;
  }

  @media (min-width: 48rem) {
    .SlideGallery {
      margin: 0 auto;
    }

    .SlideGallery__slide-image--cover {
      width: 100%;
      margin: initial;
    }
  }

  @media ${MQ_MEDIUM} {
    .SlideGallery {
      width: 100%;
      margin: initial;
    }
  }

  @media ${MQ_XLARGE} {
    .SlideGallery {
      width: 816px;
      margin: initial;
    }
  }

  /* dotIndicatorSlider variant styles */
  .SlideGallery--dotIndicatorSlider {
    position: relative;
  }

  @media ${MQ_XLARGE} {
    .SlideGallery--dotIndicatorSlider {
      width: 100%;
    }
  }
`;

export const slideStyles = css`
  .SlideGallery__slide-caption :global(a) {
    color: #ff4b2e;
  }

  .SlideGallery__slide-image {
    position: relative;
    display: grid;
    grid-template: 'image';
  }

  .SlideGallery__slide-image ul {
    overflow: hidden;
    list-style: none;
    height: calc((100vw - 2rem) * 0.75);
    display: flex;
    margin: 0 auto;
    width: 100%;
    background: #f7f7f7;
  }

  .SlideGallery__slide-image :global(.SlideGallery__slide--original) {
    grid-area: image;
    width: 100%;
  }

  .SlideGallery__slide-image :global(.PinItButton) {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    z-index: 100;
  }

  .SlideGallery__slide-image :global(.Figure__image-toolbar .PinItButton) {
    position: static;
  }

  .SlideGallery__slide-image :global(li) {
    display: none;
    position: relative;
    width: 100%;
  }

  .SlideGallery__slide-image :global(li.show) {
    display: grid;
    margin: 0 auto;
  }

  .SlideGallery__slide-image :global(li.hidden) {
    height: 0;
  }

  .SlideGallery__slide-image :global(li.show) {
    height: 100%;
  }

  .SlideGallery__slide-image :global(.SlideGallery__slide--original) {
    object-fit: contain;
    max-height: calc((100vw - 2rem) * 0.75);
  }

  .SlideGallery__slide-info {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    font-size: 12px;
    color: #666;
    flex-wrap: wrap;
  }

  .SlideGallery__slide-info :global(a) {
    color: #666;
  }

  .SlideGallery__slide-cap {
    margin: 0.5rem 0.5rem 0 0;
    flex: 0 1 auto;
  }

  .SlideGallery__slide-image--cover .SlideGallery__slide-info,
  .SlideGallery__slide-image--cover .SlideGallery__slide-meta {
    /* Cover Media Only */
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .SlideGallery__slide-meta {
    margin: 1rem 0;
  }

  :global(.SlideGallery__slide-prism) {
    flex: 0 0 auto;
  }

  .SlideGallery__slide-navigation {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    align-items: center;
  }

  .SlideGallery__cover-controls :global(button) {
    /* Cover Media Only */
    font-size: 1.5rem;
    padding: 0.5rem;
    background-color: hsla(0, 0%, 100%, 0.7);
  }

  .SlideGallery__control-icon--hidden {
    opacity: 0.5;
  }

  .SlideGallery__slide-navigation .SlideGallery__controls {
    display: flex;
  }

  .SlideGallery__slide-navigation .SlideGallery__controls :global(button) {
    border: 1px solid #2b2b2b;
    padding: 0.5rem;
    margin-left: 1rem;
    cursor: pointer;
  }

  .SlideGallery__slide-navigation
    .SlideGallery__controls
    :global(button:focus) {
    outline: 0;
  }

  .SlideGallery__cover-controls {
    /* Cover Media Only */
    position: absolute;
    width: 100%;
    top: 35%;
    display: flex;
    justify-content: space-between;
    z-index: 99;
  }

  .SlideGallery_slide-thumbnail-view {
    align-self: center;
  }

  .SlideGallery_slide-thumbnail-view a {
    color: black;
  }

  .SlideGallery_slide-thumbnail-view :global(svg) {
    font-size: 1.8rem;
  }

  .SlideGallery__slide-number {
    align-self: center;
    color: #666;
  }

  .SlideGallery__slide-caption {
    color: black;
    line-height: 1.5;
    font-size: 14px;
    border-bottom: 1px solid #eee;
    padding: 0.6rem 0;
  }

  @media ${MQ_MEDIUM} {
    .SlideGallery__slide-image ul {
      height: 544px;
      max-width: 816px;
    }

    .SlideGallery__slide-image--cover ul {
      max-width: 100vw;
      height: 800px;
    }

    .SlideGallery__slide-image--landscape.SlideGallery__slide-image--cover
      :global(.SlideGallery__slide--original) {
      width: 100%;
      min-height: 100%;
      object-fit: cover;
    }

    .SlideGallery__slide-image :global(li .SlideGallery__slide--original) {
      max-height: 544px;
    }

    .SlideGallery__cover-controls {
      top: 400px; /* 800 / 2 */
    }
  }

  @media ${MQ_LARGE} {
    .SlideGallery__slide-image--cover :global(.SlideGallery__slide--original) {
      min-height: 800px;
      width: 100%;
    }

    .SlideGallery__slide-image--landscape.SlideGallery__slide-image--cover
      :global(.SlideGallery__slide--original) {
      min-height: 800px;
      object-fit: inherit;
    }

    .SlideGallery__slide-image :global(.SlideGallery__slide--original),
    .SlideGallery__slide-image video,
    .SlideGallery__slide-image__placeholder {
      min-height: 544px;
    }

    .SlideGallery__slide-meta {
      margin: 1rem 0 2rem;
    }

    .SlideGallery__slide-navigation {
      margin: 0 auto;
    }

    .SlideGallery__slide-caption {
      padding: 1rem 0 1rem;
    }
  }

  /* dotIndicatorSlider variant styles */
  .SlideGallery__slide-image--dotIndicatorSlider {
    grid-template-areas:
      '..........'
      'indicators'
      'caption';
    grid-template-columns: [image-start] 1fr [image-end];
    grid-template-rows: [image-start] auto max-content [image-end] auto;
    grid-template-rows: [image-start] auto -webkit-max-content [image-end] auto;
  }

  .SlideGallery__slide-image--dotIndicatorSlider ul {
    grid-area: image;
    background-color: ${warmGrays[0]};
    height: calc(100vw * 1.25);
  }

  :global(.SlideGallery__slide-image--dotIndicatorSlider.SlideGallery__slide-image--landscape
      img) {
    position: unset;
    top: 0;
  }

  .SlideGallery__slide-image--dotIndicatorSlider
    :global(.SlideGallery__slide-caption) {
    grid-area: caption;
    margin-top: 0.25rem;
    padding: 0 1rem;
    border-bottom: 0;
    font-size: var(--fontScaleNeg2);
  }

  .SlideGallery__slide-image--dotIndicatorSlider
    :global(.SlideGallery__slideImageWrapper) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .SlideGallery__slide-image--dotIndicatorSlider
    .SlideGallery__slide-navigation {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    justify-content: space-between;
    width: 100%;
    pointer-events: none; /* don't block swipe events */
  }

  .SlideGallery__slide-image--dotIndicatorSlider
    .SlideGallery__slide-navigation
    :global(button) {
    padding: 0.5rem;
    margin: 1rem;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.75);
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.6);
    font-size: 1.2rem;
    color: #000;
    cursor: pointer;
    pointer-events: all; /* allow click events */
  }

  .SlideGallery__slide-image--dotIndicatorSlider
    :global(.SlideGallery__slide-number) {
    grid-area: indicators;
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .SlideGallery__slide-image--dotIndicatorSlider
    :global(.SlideGallery__slide-number .SlideGallery__slide-indicator) {
    display: inline-block;
    height: 0.75rem;
    width: 0.75rem;
    margin: 0.25rem;
    background-color: #fff;
    border: 2px solid #fff;
    border-radius: 50%;
    opacity: 0.5;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.6);
  }

  .SlideGallery__slide-image--dotIndicatorSlider
    :global(.SlideGallery__slide-number
      .SlideGallery__slide-indicator--active) {
    opacity: 0.95;
    background-color: #000;
  }

  .SlideGallery__slide-image--dotIndicatorSlider
    :global(.SlideGallery__slide--original) {
    max-height: calc(100vw * 1.25);
  }

  /* Special height for Small/Cool entry pages */
  :global(.SmallCoolEntry) .SlideGallery__slide-image--dotIndicatorSlider ul {
    height: calc(100vw * 0.667);
  }

  :global(.SmallCoolEntry)
    .SlideGallery__slide-image--dotIndicatorSlider
    .SlideGallery__slide-navigation {
    top: calc((100vw * 0.667) / 2);
  }

  :global(.SmallCoolEntry)
    .SlideGallery__slide-image--dotIndicatorSlider
    :global(.SlideGallery__slide--original) {
    max-height: calc(100vw * 0.667);
  }

  /* Unique mid-way breakpoint */
  @media (min-width: 640px) {
    :global(.SmallCoolEntry) .SlideGallery__slide-image--dotIndicatorSlider ul {
      height: calc(640px * 0.667);
    }

    :global(.SmallCoolEntry)
      .SlideGallery__slide-image--dotIndicatorSlider
      :global(.SlideGallery__slide--original) {
      max-height: calc(640px * 0.667);
    }

    :global(.SmallCoolEntry)
      .SlideGallery__slide-image--dotIndicatorSlider
      .SlideGallery__slide-navigation {
      top: calc((640px * 0.667) / 2);
    }
  }

  @media ${MQ_LARGE} {
    :global(.SmallCoolEntry) .SlideGallery__slide-image--dotIndicatorSlider ul {
      height: 540px;
    }

    :global(.SmallCoolEntry)
      .SlideGallery__slide-image--dotIndicatorSlider
      :global(.SlideGallery__slide--original) {
      max-height: 540px;
      min-height: unset;
    }

    .SlideGallery__slide-image--dotIndicatorSlider
      :global(.SlideGallery__slide-caption) {
      margin-top: 0.5rem;
      padding: 0;
      font-size: var(--fontScaleNeg1);
    }

    :global(.SmallCoolEntry)
      .SlideGallery__slide-image--dotIndicatorSlider
      .SlideGallery__slide-navigation {
      top: 270px;
    }

    :global(.SmallCoolEntry--2021)
      .SlideGallery__slide-image--dotIndicatorSlider
      ul {
      background-color: #f5f0e7;
    }

    :global(.SmallCoolEntry--2021)
      .SlideGallery__slide-image--dotIndicatorSlider
      ul,
    :global(.SmallCoolEntry--2021)
      .SlideGallery__slide-image--dotIndicatorSlider
      :global(.SlideGallery__slide--original) {
      height: calc((100vh - 6rem) - 64px);
      max-height: 540px;
    }
  }

  @media ${MQ_MIDLARGE} {
    :global(.SmallCoolEntry) .SlideGallery__slide-image--dotIndicatorSlider ul {
      height: 640px;
    }

    :global(.SmallCoolEntry)
      .SlideGallery__slide-image--dotIndicatorSlider
      :global(.SlideGallery__slide--original) {
      max-height: 640px;
    }

    :global(.SmallCoolEntry)
      .SlideGallery__slide-image--dotIndicatorSlider
      .SlideGallery__slide-navigation {
      top: 320px;
    }

    :global(.SmallCoolEntry--2021)
      .SlideGallery__slide-image--dotIndicatorSlider
      ul,
    :global(.SmallCoolEntry--2021)
      .SlideGallery__slide-image--dotIndicatorSlider
      :global(.SlideGallery__slide--original) {
      height: calc((100vh - 6rem) - 64px);
      max-height: 540px;
    }
  }
`;

export const thumbnailStyles = css`
  .SlideGallery__thumbnail {
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    background: white;
    z-index: 1000000000;
    overflow: auto;
  }

  .SlideGallery__thumbnail ul {
    list-style: none;
    margin: 0 auto;
    width: 95%;
  }

  .SlideGallery__thumbnail ul li {
    margin: 0.5rem auto;
  }

  .SlideGallery__thumbnail .SlideGallery__thumbnail--placeholder {
    min-height: 210px;
  }

  .SlideGallery__thumbnail ul li :global(.SlideGallery__slide--original) {
    width: 100%;
    margin: 0 auto;
  }

  .SlideGallery__thumbnail .SlideGallery__thumbnail--caption {
    font-size: 13px;
    margin: 8px 0px 15px 0px;
    white-space: wrap;
  }

  .SlideGallery__thumbnail .SlideGallery__thumbnail--caption :global(a) {
    color: #ff4b2e;
  }

  .SlideGallery__thumbnail :global(.SlideGallery__slide-prism) {
    margin-top: 0.5rem;
    display: inline-block;
  }

  .SlideGallery__thumbnail-controls {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 1rem;
    font-weight: bold;
  }

  .SlideGallery__thumbnail-controls a {
    color: black;
    font-weight: bold;
  }

  @media ${MQ_MEDIUM} {
    .SlideGallery__thumbnail ul {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      width: 100%;
    }
    .SlideGallery__thumbnail ul li :global(.SlideGallery__slide--original) {
      max-height: 200px;
      width: inherit;
      margin: inherit;
    }
    .SlideGallery__thumbnail .SlideGallery__thumbnail--caption {
      margin: 0 5 0 5px;
      max-width: 220px;
    }
  }

  @media ${MQ_LARGE} {
    .SlideGallery__thumbnail ul {
      flex-wrap: wrap;
      margin: 0;
    }
    .SlideGallery__thumbnail .SlideGallery__thumbnail--caption {
      margin: 0 5 0 5px;
      max-width: 220px;
    }

    .SlideGallery__thumbnail ul li {
      margin: 1rem;
    }

    .SlideGallery__thumbnail-controls {
      width: 80%;
      margin: 0 auto;
    }
  }
`;
